import { render } from "./ConversionRate.vue?vue&type=template&id=1908e5a5&scoped=true"
import script from "./ConversionRate.vue?vue&type=script&lang=js"
export * from "./ConversionRate.vue?vue&type=script&lang=js"

import "./ConversionRate.vue?vue&type=style&index=0&id=1908e5a5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1908e5a5"]])

export default __exports__